"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.status.pending': 'Pending',
    'payment.status.success': 'Success',
    'payment.status.rejected': 'Rejected',
    'payment.status.error': 'Error',
    'payment.status.unknown': 'Unknown',
};
